/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Moment from 'vue-moment'
import store from './store' // Make sure you have a store/index.js
import VueSweetalert2 from 'vue-sweetalert2'
import plugins from './plugins'


import 'sweetalert2/dist/sweetalert2.min.css';
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css'
import "@/assets/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"

// assets
import '@/assets/css/all.min.css'
import '@/assets/css/app.css'
import '@/assets/css/responsive.css'


let env = process.env;

// Set Vue prototypes for global access
Vue.prototype.$server = env.VUE_APP_API_BASE_URL;
Vue.prototype.$ui = env.VUE_APP_SERVER_HOST;
Vue.prototype.$auth = env.VUE_APP_AUTH_API;
Vue.prototype.$auth_ui = env.VUE_APP_AUTH_UI;
Vue.prototype.$axios = plugins.axios;

// Setup axios interceptors by passing the store
plugins.setupAxios(store);

// Custom toolbar for a rich text editor (e.g., Quill)
Vue.prototype.$customToolbar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ["bold", "italic", "underline", "strike"],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    ["clean"]
];

// JWT parsing function - defined once
function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error("Error parsing JWT", e);
        return null;
    }
}

Vue.mixin({
    methods: {
        // The parseJwt function is now internal to the auth store.
        // Components should not need to call it directly.
    },
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

// Configure plugins
Vue.use(VueSweetalert2, {
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'success'
});

Vue.use(Moment);